import * as charts from "../../charts/";
import { ChartType } from "../../entities/reportEntity";

export default {
  id: 4,
  label: "年度发明人数分析",
  chart: charts.lineAndBar,
  definition: {
    rowDims: [{ name: "appDate", label: "申请年", dateUnit: "YEAR", limit: 10, needTotal: true }],
    colDims: [],
    measures: [{ name: "inventor", label: "发明人数", table: "patent_inventor", sortBy: "DESC" }],
    showNoDataDims: true,
  },
  chartOption: {
    chartType: ChartType.LINE,
    title: "年度发明人数分析",
    subTitle: "",
    hideTitle: false,
    xaxisTitle: "",
    yaxisTitle: "",
    hideAxisTitle: true,
    hideLabel: false,
    hideLegend: false,
    hideToolbox: false,
  },
};
